<template>
  <v-app>
    <v-main>
      <v-container fluid class="pa-0">
        <v-row no-gutters>
          <v-col
            cols="12"
            md="4"
            class="d-flex flex-column align-center justify-center pa-5 left-column"
          >
            <v-row></v-row>
            <v-row
              ><v-img src="@/assets/images/logo_pitch.png" contain lazy></v-img
            ></v-row>
            <v-row dense class="pa-0">
              <div>
                <h6 style="font-size: 19.2px">Welcome to Pitch Connect</h6>
                <h6 style="font-size: 27.6px">Qual caminho deseja seguir ?</h6>
              </div>
            </v-row>

            <v-row no-gutters class="pa-0">
              <div>
                <v-row dense class="mb-3 mt-2">
                  <v-card
                    @click="setScreen('Customer')"
                    elevation="3"
                    min-width="40vh"
                    class="primary radius5 select-card"
                  >
                    <v-card-text>
                      <span
                        class="white--text poppins"
                        style="
                          background-clip: text;
                          font-size: 16 !important;
                          font-weight: bold;
                        "
                      >
                        Aluno
                      </span>
                    </v-card-text>
                  </v-card>
                </v-row>
                <v-row dense class="mb-3 mt-2">
                  <v-card
                    @click="setScreen('Partner')"
                    elevation="3"
                    width="40vh"
                    class="primary radius5 select-card"
                  >
                    <v-card-text>
                      <span
                        class="white--text poppins"
                        style="
                          background-clip: text;
                          font-size: 16 !important;
                          font-weight: bold;
                        "
                      >
                        Professor
                      </span>
                    </v-card-text>
                  </v-card>
                </v-row>
              </div>
            </v-row>

            <v-row dense align="end" justify="center">
              <CopyRight />
            </v-row>
          </v-col>

          <v-col cols="12" md="8">
            <v-img
              src="@/assets/images/connect/main_screen_image-min.webp"
              class="full-height-image"
              cover
              lazy
            >
              <v-container
                class="d-flex align-center pa-5 justify-center"
                style="margin-top: 55vh"
              >
                <div>
                  <h1
                    class="display-2 white--text font-weight-bold overlay-title"
                  >
                    Welcome to Pitch Connect
                  </h1>

                  <p class="white--text">Login to access your account</p>
                </div>
              </v-container>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import CopyRight from "../CopyRight.vue";

export default {
  name: "ModuleSelection",
  components: {
    CopyRight,
  },
  created() {
    if (localStorage.getItem("module")) {
      switch (localStorage.getItem("module")) {
        case "aluno":
          return this.setScreen("Customer");
        case "professor":
          return this.setScreen("Partner");
        default:
          break;
      }
      this.$route.query = {};
    }
  },
  methods: {
    setScreen(value) {
      this.$emit("selected", value);
    },
  },
};
</script>

<style scoped>
.left-column {
  text-align: center;
}

.full-height-image {
  height: 100vh;
  width: 100vw;
  background-image: url("../../assets/images/connect/main_screen_image-min.webp");
}

h1,
h2,
h4,
h6 {
  color: var(--dk-pink-deep, #a90e61);
}

.v-btn {
  background-color: var(--dk-pink-deep, #a90e61);
  color: white;
}

.v-btn:hover {
  background-color: #900c55;
}

.radius5 {
  border-radius: 5px;
}

/* Mobile (coluna empilhada, < 960px): dava para ver texto e botoes grudados e
   os cards estouravam a largura por usarem 40vh (largura baseada na ALTURA da
   viewport). Aqui damos respiro vertical e contemos os cards, sem mexer no
   desktop. */
@media (max-width: 959.98px) {
  .left-column {
    gap: 22px;
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .select-card {
    width: min(82vw, 340px) !important;
    min-width: 0 !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .overlay-title {
    font-size: 2rem !important;
    line-height: 1.15 !important;
  }
}
</style>
